import ApiCoreService from "./api.core.service";

export default class LoginService extends ApiCoreService {
    static async sendOtp(phoneNumber, caNumber, uType, regMode) {
        console.log(phoneNumber, caNumber, uType="PROSUMER", regMode);
        try {
            return await this.graphCall('sendOtpForInter', `{
                sendOtpForInter(email: "${phoneNumber}@p2penergy.ai", phone: "${phoneNumber}", aggregatorCode: "vb_inters", uType: ${uType}, caNumber: "${caNumber}", regMode: ${regMode})
                {
                    success
                    ctx
                }
            }`);
        } catch (c) {
            throw new Error(c);
        }
    }

    static async sendAggOtp(phoneNumber, email, aggregatorCode) {
        try {
            return await this.graphCall('sendOtpForAggregator', `{
                sendOtpForAggregator(email: "${email}" phone: "${phoneNumber}" aggregatorCode: "${aggregatorCode}") {
                    success
                    ctx
                }
            }`);
        } catch (c) {
            throw new Error(c);
        }
    }

    static async verifyOtp(otp, ctx) {
        try {
            return await this.graphCall(
                "verifyP2POtp",
                `{
                verifyP2POtp(otp: "${otp}", ctx: "${ctx}") {
                    success
                    token
                    id
                }
            }`,
                {}
            );
        } catch (c) {
            throw new Error(c);
        }
    }

    static get token() {
        const token = localStorage.getItem('_token'); // Fetch from localStorage
        return token ? token : null;
    }

   

   
}
